<template>
  <!-- eslint-disable vue/component-name-in-template-casing, vue/no-unused-vars -->
  <transition name="fade-in">
    <div v-if="visible" class="global-search-overlay" @click.self="close">
      <div class="search-modal-container">
        <!-- 搜索头部 -->
        <div class="search-modal-header">
          <font-awesome-icon icon="search" class="search-input-icon" />
          <input
            ref="searchInput"
            v-model="query"
            type="text"
            placeholder="搜索菜单、游戏、渠道名称/ID..."
            class="search-raw-input"
            @keydown.down.prevent="moveDown"
            @keydown.up.prevent="moveUp"
            @keydown.enter.prevent="selectCurrent"
            @keydown.esc="close"
          />
          <span class="search-esc-hint" @click="close">ESC</span>
        </div>

        <!-- 搜索结果区域 -->
        <div class="search-modal-body" ref="resultsContainer">
          <!-- 默认状态 / 引导提示 -->
          <div v-if="!query && !results.length" class="search-default-tips">
            <div class="tips-group">
              <span class="tips-group-title">常用页面导航</span>
              <div class="tips-items">
                <div
                  v-for="(item, idx) in defaultQuickMenus"
                  :key="idx"
                  class="tips-item-card"
                  @click="handleMenuClick(item)"
                >
                  <font-awesome-icon :icon="item.icon" class="tip-icon" />
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 搜索结果列表 -->
          <template v-else-if="results.length">
            <div v-for="(group, groupName) in groupedResults" :key="groupName" class="result-group">
              <div class="result-group-title">{{ groupName }}</div>
              <div class="result-group-list">
                <div
                  v-for="item in group"
                  :key="item.uniqueId"
                  :class="['result-item', { active: activeIndex === item.index }]"
                  @mouseenter="activeIndex = item.index"
                  @click="triggerSelect(item)"
                >
                  <div class="result-item-left">
                    <font-awesome-icon :icon="item.icon" class="item-icon" />
                    <span class="item-text">
                      <span class="item-main-name">{{ item.name }}</span>
                      <span v-if="item.subInfo" class="item-sub-info">（{{ item.subInfo }}）</span>
                    </span>
                  </div>
                  <div class="result-item-right">
                    <span class="jump-badge">跳转 <font-awesome-icon icon="arrow-right" /></span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- 空状态 -->
          <div v-else class="search-empty-state">
            <font-awesome-icon icon="face-frown" class="empty-icon" />
            <div class="empty-title">未找到与“{{ query }}”匹配的结果</div>
            <div class="empty-desc">请尝试输入其他关键词，如游戏名称或渠道 ID</div>
          </div>
        </div>

        <!-- 底部快捷键提示 -->
        <div class="search-modal-footer">
          <div class="footer-hint-item">
            <kbd>↑↓</kbd> <span>选择</span>
          </div>
          <div class="footer-hint-item">
            <kbd>Enter</kbd> <span>跳转</span>
          </div>
          <div class="footer-hint-item">
            <kbd>Esc</kbd> <span>关闭</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalSearch',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      query: '',
      activeIndex: 0,
      menus: [
        { name: '首页', path: '/home', icon: 'home', group: '首页' },
        { name: '游戏管理', path: '/p', icon: 'project-diagram', group: '游戏管理' },
        { name: '渠道列表', path: '/c/cl', icon: 'plug', group: '渠道接入' },
        { name: '平台规划', path: '/pl', icon: 'sliders-h', group: '渠道接入' },
        { name: '渠道类型', path: '/ct', icon: 'tags', group: '渠道接入' },
        { name: 'Visitor逻辑', path: '/l', icon: 'microchip', group: '渠道接入' },
        { name: '同步参数', path: '/n', icon: 'sync', group: '渠道接入' },
        { name: 'XS游戏', path: '/xs/args/game', icon: 'gamepad', group: '登录支付' },
        { name: 'XS渠道', path: '/xs/args/channel', icon: 'link', group: '登录支付' },
        { name: 'XS逻辑', path: '/xs/args/logic', icon: 'cog', group: '登录支付' },
        { name: '支付Agrs', path: '/xs/args/pay', icon: 'coins', group: '登录支付' },
        { name: '电信认证', path: '/xs/telecom/auth', icon: 'mobile-alt', group: '登录支付' },
        { name: '商户组', path: '/mch/group', icon: 'layer-group', group: '商户配置' },
        { name: '微信商户', path: '/mch/wx', icon: 'comments', group: '商户配置' },
        { name: '支付宝商户', path: '/mch/ali', icon: ['fab', 'alipay'], group: '商户配置' },
        { name: 'Apple应用', path: '/mch/apple', icon: ['fab', 'apple'], group: '商户配置' },
        { name: 'Ext游戏', path: '/ext/config/game', icon: 'puzzle-piece', group: '扩展配置' },
        { name: 'Ext渠道', path: '/ext/config/channel', icon: 'link', group: '扩展配置' },
        { name: 'Ext模版', path: '/ext/config/template', icon: 'cubes', group: '扩展配置' },
        { name: '节假日', path: '/holiday', icon: 'calendar-alt', group: '环境配置' },
        { name: '卸载菜单', path: '/menu', icon: 'list-ul', group: '环境配置' },
        { name: '网关域名', path: '/area', icon: 'network-wired', group: '环境配置' },
        { name: 'UFO分组', path: '/ufo/group', icon: 'layer-group', group: '环境配置' },
        { name: '证书配置', path: '/pkg', icon: 'certificate', group: '环境配置' },
        { name: '节点内存', path: '/ufw', icon: 'memory', group: 'UFW' },
        { name: '黑名单', path: '/ufw/black', icon: 'user-slash', group: 'UFW' },
        { name: '白名单', path: '/ufw/white', icon: 'user-check', group: 'UFW' },
        { name: '广告应用', path: '/advert/app', icon: 'ad', group: '广告变现' },
        { name: '广告渠道', path: '/advert/channel', icon: 'yen-sign', group: '广告变现' },
        { name: '公司管理', path: '/company', icon: 'building', group: '公司主体' },
        { name: '组织管理', path: '/organize', icon: 'users', group: '公司主体' },
        { name: '应用分配', path: '/wiki/app', icon: 'cube', group: '其他' },
        { name: 'VPC规划', path: '/wiki/vpc', icon: 'network-wired', group: '其他' }
      ]
    }
  },
  computed: {
    // 默认快捷菜单推荐
    defaultQuickMenus () {
      return [
        { name: '首页', path: '/home', icon: 'home' },
        { name: '渠道列表', path: '/c/cl', icon: 'plug' },
        { name: '游戏管理', path: '/p', icon: 'project-diagram' },
        { name: 'XS游戏', path: '/xs/args/game', icon: 'gamepad' }
      ]
    },
    // 获取全局游戏产品列表
    games () {
      return this.$store.getters.appList || []
    },
    // 获取当前游戏下的渠道列表
    channels () {
      return this.$store.getters.channelList || []
    },
    // 综合过滤出的扁平化结果
    results () {
      if (!this.query.trim()) return []

      const q = this.query.toLowerCase().trim()
      const list = []

      // 1. 匹配功能菜单
      this.menus.forEach(m => {
        if (m.name.toLowerCase().includes(q)) {
          list.push({
            type: 'menu',
            group: '功能菜单',
            name: m.name,
            icon: m.icon,
            path: m.path,
            uniqueId: `menu-${m.path}`
          })
        }
      })

      // 2. 匹配游戏
      this.games.forEach(g => {
        const gameIdStr = String(g.id)
        if (g.name.toLowerCase().includes(q) || gameIdStr.includes(q)) {
          list.push({
            type: 'game',
            group: '游戏（切换上下文）',
            name: g.name,
            icon: 'gamepad',
            id: g.id,
            subInfo: `ID: ${g.id}`,
            uniqueId: `game-${g.id}`
          })
        }
      })

      // 3. 匹配渠道（仅限当前游戏上下文下的渠道）
      this.channels.forEach(c => {
        const channelIdStr = String(c.id)
        if (c.name.toLowerCase().includes(q) || channelIdStr.includes(q)) {
          list.push({
            type: 'channel',
            group: '当前游戏渠道',
            name: c.name,
            icon: 'link',
            id: c.id,
            subInfo: `ID: ${c.id}`,
            uniqueId: `channel-${c.id}`
          })
        }
      })

      // 扁平化注入对应的索引 index
      return list.map((item, idx) => ({
        ...item,
        index: idx
      }))
    },
    // 将结果按 group 分组，方便分类渲染
    groupedResults () {
      const groups = {}
      this.results.forEach(item => {
        if (!groups[item.group]) {
          groups[item.group] = []
        }
        groups[item.group].push(item)
      })
      return groups
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.query = ''
        this.activeIndex = 0
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
        // 挂载键盘监听
        document.addEventListener('keydown', this.handleKeyDown)
      } else {
        document.removeEventListener('keydown', this.handleKeyDown)
      }
    },
    query () {
      this.activeIndex = 0
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    moveDown () {
      if (this.results.length === 0) return
      this.activeIndex = (this.activeIndex + 1) % this.results.length
      this.scrollToActive()
    },
    moveUp () {
      if (this.results.length === 0) return
      this.activeIndex = (this.activeIndex - 1 + this.results.length) % this.results.length
      this.scrollToActive()
    },
    selectCurrent () {
      if (this.results.length > 0 && this.results[this.activeIndex]) {
        this.triggerSelect(this.results[this.activeIndex])
      }
    },
    handleMenuClick (menu) {
      this.$router.push(menu.path)
      this.close()
    },
    triggerSelect (item) {
      if (item.type === 'menu') {
        this.$router.push(item.path)
      } else if (item.type === 'game') {
        // 切换游戏上下文并刷新页面
        this.$store.dispatch('ChangeApp', item.id).then(() => {
          this.$message.success(`已成功切换至游戏：${item.name}`)
          window.location.reload()
        })
      } else if (item.type === 'channel') {
        // 跳转至渠道列表并加上过滤 query
        this.$router.push({
          path: '/c/cl',
          query: { search: item.name }
        })
      }
      this.close()
    },
    scrollToActive () {
      this.$nextTick(() => {
        const container = this.$refs.resultsContainer
        const activeEl = container.querySelector('.result-item.active')
        if (activeEl) {
          const containerHeight = container.clientHeight
          const elemTop = activeEl.offsetTop
          const elemHeight = activeEl.clientHeight
          if (elemTop + elemHeight > container.scrollTop + containerHeight) {
            container.scrollTop = elemTop + elemHeight - containerHeight
          } else if (elemTop < container.scrollTop) {
            container.scrollTop = elemTop
          }
        }
      })
    },
    handleKeyDown (e) {
      // 拦截 Esc
      if (e.key === 'Escape') {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
.global-search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--bg-search-overlay);
  backdrop-filter: blur(8px);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10vh;
}

.search-modal-container {
  width: 600px;
  max-width: 90%;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25), 0 8px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.search-modal-header {
  display: flex;
  align-items: center;
  margin: 12px;
  padding: 10px 12px;
  border: 1px solid var(--border-search-input);
  border-radius: 10px;
  background: var(--bg-page);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  transition: border-color 0.25s, box-shadow 0.25s;
}

.search-modal-header:focus-within {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) !important;
}

html.dark .search-modal-header:focus-within {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25) !important;
}

.search-input-icon {
  color: #2563eb;
  font-size: 15px;
  margin-right: 12px;
}

.search-raw-input {
  flex: 1;
  background: transparent;
  border: none;
  color: var(--text-main);
  font-size: 15px;
  outline: none;
  font-family: inherit;
}

.search-raw-input::placeholder {
  color: var(--text-muted);
}

.search-esc-hint {
  font-size: 11px;
  color: var(--text-muted);
  background: var(--bg-card);
  border: 1px solid var(--border-hover);
  padding: 2px 7px;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
}

.search-modal-body {
  max-height: 420px;
  overflow-y: auto;
  padding: 12px;
}

/* 隐藏滚动条 */
.search-modal-body::-webkit-scrollbar {
  width: 6px;
}
.search-modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.search-modal-body::-webkit-scrollbar-thumb {
  background: var(--border-hover);
  border-radius: 3px;
}

/* 默认状态 */
.search-default-tips {
  padding: 8px;
}

.tips-group-title {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: block;
  margin-bottom: 10px;
}

.tips-items {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.tips-item-card {
  display: flex;
  align-items: center;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  padding: 10px 14px;
  border-radius: 8px;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13.5px;
}

.tips-item-card:hover {
  background: var(--bg-tip-hover);
  border-color: var(--border-tip-hover);
  color: var(--text-tip-hover);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.08);
}

.tip-icon {
  margin-right: 10px;
  color: #2563eb;
}

/* 搜索结果 */
.result-group {
  margin-bottom: 16px;
}

.result-group:last-child {
  margin-bottom: 8px;
}

.result-group-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  padding: 0 8px 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 12px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.15s ease;
  margin-bottom: 2px;
}

.result-item-left {
  display: flex;
  align-items: center;
  color: var(--text-main);
  font-size: 13.5px;
}

.item-icon {
  margin-right: 12px;
  color: var(--text-muted);
  width: 16px;
  text-align: center;
}

.item-main-name {
  font-weight: 500;
}

.item-sub-info {
  color: var(--text-muted);
  font-size: 12px;
}

.result-item-right {
  opacity: 0;
  transition: opacity 0.15s ease;
}

.jump-badge {
  font-size: 11px;
  color: var(--text-jump-badge);
  background: var(--bg-jump-badge);
  padding: 2px 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.result-item.active {
  background: var(--bg-tip-hover);
  border-color: var(--border-tip-hover);
  color: var(--text-main);
}

.result-item.active .item-icon {
  color: #2563eb;
}

.result-item.active .result-item-right {
  opacity: 1;
}

/* 空状态 */
.search-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  color: var(--text-muted);
}

.empty-icon {
  font-size: 32px;
  margin-bottom: 12px;
  color: var(--border-hover);
}

.empty-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-main);
  margin-bottom: 4px;
}

.empty-desc {
  font-size: 12px;
  color: var(--text-muted);
}

/* 底部 */
.search-modal-footer {
  display: flex;
  align-items: center;
  padding: 10px 18px;
  background: var(--bg-page);
  border-top: 1px solid var(--border-color);
  font-size: 11px;
  color: var(--text-muted);
  gap: 16px;
}

.footer-hint-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.footer-hint-item kbd {
  background: var(--bg-card);
  border: 1px solid var(--border-hover);
  padding: 1px 4px;
  border-radius: 3px;
  color: var(--text-muted);
}

/* 动画效果 */
.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}
.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
</style>
